import React from "react";
import Select from "components/FormComponents/Select/Select";

export default function SelectColumnFilter(props) {
	const { column: { filterValue, setFilter, preFilteredRows, id, options, filter, Header }} = props;
	return (
		<Select label={`${Header}`} size="small" value={filterValue} options={options} onChange={setFilter} filter={filter} style={{background:"white", border:"1px solid #CACEDA", borderColor:"#CACEDA", borderRadius:5}} placeholderStyle={{color:"#CACEDA"}}   />
	);
}
